import {
  TASK_STATUS_LABELS,
  MESSAGES,
  getStatusIconAndColor,
} from "../Constants";

const StatusBadge = ({ status }) => {
  if (!status)
    return <span className="text-gray-400 italic">{MESSAGES.NOT_SET}</span>;

  const { icon, color } = getStatusIconAndColor(status);

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${color} whitespace-nowrap`}
    >
      <span className="flex items-center">{icon}</span>
      <span>{TASK_STATUS_LABELS[status] || status}</span>
    </span>
  );
};

const ProjectSiteDetailsInfo = ({ task }) => {
  if (!task) return null;

  return (
    <div className="h-full px-2">
      <h2 className="text-lg font-semibold mb-3 text-primary">
        <span className="border-b-2 border-gray-300 pb-1 inline-block">
          Project & Site Details
        </span>
      </h2>

     <div className="grid grid-cols-2 gap-4 text-sm mb-1">
        <strong className="text-gray-800">Project Name</strong>
        <strong className="text-gray-800">Site Name</strong>
      </div>

      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="flex flex-col md:flex-row justify-center md:justify-start items-start md:items-center md:gap-8 gap-2">
          <span className="truncate text-gray-700">
            {task.project_name || MESSAGES.NOT_SET}
          </span>
          <StatusBadge status={task.project_status} />
        </div>

        <div className="flex flex-col md:flex-row justify-center md:justify-start items-start md:items-center md:gap-8 gap-2">
          <span className="truncate text-gray-700">
            {task.site_name || MESSAGES.NOT_SET}
          </span>
          <StatusBadge status={task.site_status} />
        </div>
      </div>
    </div>
  );
};

export default ProjectSiteDetailsInfo;
